import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface SnackbarData {
    message: string;
    type: 'success' | 'error' | 'warning';
}

@Component({
    selector: 'lokos-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrl: './snackbar.component.scss',
    standalone: false,
})
export class SnackbarComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
        public snackBarRef: MatSnackBarRef<SnackbarComponent>
    ) {}

    onClose() {
        this.snackBarRef.dismiss();
    }
}
